import { Map } from '@Models';
import { TYPES } from '@Types';
import { RequestAction } from '@Repository/RequestAction';
import { MapRepository, RequestMapSuccess } from '@Repository/ninthAge';
import { inject, injectable } from 'inversify';
import mapSlice from '@Redux/reducers/ninthage/map.slice';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IEntityAction } from '@Redux/IEntityAction';

@injectable()
export class MapAction extends IEntityAction<number, Map, RequestMapSuccess> {
  @inject(TYPES.Repository.MapRepository) private _repository!: MapRepository;

  protected fetchDataSuccess(items: Map): PayloadAction<Map> {
    return mapSlice.actions.setMap(items);
  }

  protected cacheDataSuccess(items: Map): PayloadAction<Map> {
    return mapSlice.actions.setMap(items);
  }

  protected haveError(message: string): PayloadAction<string> {
    return mapSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return mapSlice.actions.setLoading(bool);
  }

  protected getCachedItem({
    entityId,
    locale,
  }: {
    entityId: number;
    locale: string | null;
  }): Promise<Map | null> {
    return this._repository.getCached(entityId, { locale: null });
  }

  protected getItem({
    entityId,
    locale,
  }: {
    entityId: number;
    locale: string | null;
  }): Promise<RequestAction> {
    return this._repository.get(entityId, { locale: null });
  }
}
